export default "__VITE_ASSET__B9g2q8vk__"